const ANONYMOUS_VISITOR_ID_KEY = 'touchvoice.telemetry.anonymousVisitorId';
const SESSION_ID_KEY = 'touchvoice.telemetry.sessionId';
const FUNNEL_ID_KEY = 'touchvoice.telemetry.funnelId';

export type TelemetryCorrelationIds = {
  anonymousVisitorId: string;
  sessionId: string;
  funnelId: string;
};

export function getTelemetryCorrelationIds(): TelemetryCorrelationIds {
  return {
    anonymousVisitorId: getOrCreateStoredId('localStorage', ANONYMOUS_VISITOR_ID_KEY),
    sessionId: getOrCreateStoredId('sessionStorage', SESSION_ID_KEY),
    funnelId: getOrCreateStoredId('sessionStorage', FUNNEL_ID_KEY),
  };
}

export function getTelemetryCorrelationHeaders(): Record<string, string> {
  const ids = getTelemetryCorrelationIds();
  return {
    'x-touchvoice-anonymous-visitor-id': ids.anonymousVisitorId,
    'x-touchvoice-session-id': ids.sessionId,
    'x-touchvoice-funnel-id': ids.funnelId,
  };
}

function getOrCreateStoredId(storageType: 'localStorage' | 'sessionStorage', key: string): string {
  const existing = readStorage(storageType, key);
  if (existing) return existing;

  const created = createId();
  writeStorage(storageType, key, created);
  return created;
}

function readStorage(storageType: 'localStorage' | 'sessionStorage', key: string): string | null {
  if (typeof window === 'undefined') return null;
  try {
    const value = window[storageType].getItem(key);
    return value?.trim() || null;
  } catch {
    return null;
  }
}

function writeStorage(storageType: 'localStorage' | 'sessionStorage', key: string, value: string): void {
  if (typeof window === 'undefined') return;
  try {
    window[storageType].setItem(key, value);
  } catch {
    // Storage can be unavailable in privacy-restricted contexts.
  }
}

function createId(): string {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  return `tv-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 12)}`;
}
